/**
 * Google Tag Manager frontend compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

export const DL_VAL_NOT_APPLICABLE = 'N/A';
